import SignaturePad from 'signature_pad';

(function () {
  'use strict';

  angular
    .module(
      'doxy.realtime.components.teleconsent.action.document.signature',
      []
    )
    .factory('signatureFactory', function (User) {
      function getIp() {
        return User.myself().$promise.then((res) => res.ip);
      }

      return {
        getIp: getIp,
      };
    })
    .controller(
      'TcSignatureController',
      function (
        $q,
        $document,
        $scope,
        $filter,
        signatureFactory,
        publisherManager,
        photoFactory
      ) {
        $scope.model = $scope.model || {};
        $scope.model.signing = false;
        this.state = {
          type: null,
        };

        const getPicture = () => {
          if (this.state.type === 'photo') {
            $scope.model.namePicture = photoFactory.getTextImage(
              $scope.model.name
            );
            return publisherManager.capturePhotoWithCrop({
              width: 370,
              height: 370,
            });
          } else {
            return $q(function (resolve, reject) {
              if ($scope.signaturePad.isEmpty()) return reject('No data');
              resolve($scope.signaturePad.toDataURL());
              $scope.signaturePad.clear();
            });
          }
        };

        this.selectPhoto = function () {
          if ($scope.disabled) return;
          this.state.type = 'photo';
          $scope.model.signing = true;
          $scope.model.signIp = $scope.me.privateData.ip;
        };

        this.selectDraw = function () {
          if ($scope.disabled) return;
          this.state.type = 'draw';
          $scope.model.signing = true;
          $scope.model.signIp = $scope.me.privateData.ip;
          if ($scope.model.picture && $scope.model.type === 'draw') {
            $scope.signaturePad.fromDataURL($scope.model.picture);
          }
        };

        this.accept = () => {
          $scope.model.signing = false;
          $scope.model.signIp = null;
          if (!$scope.model.name && this.state.type === 'photo') return;
          getPicture().then((picture) => {
            $scope.model.date = $filter('date')(new Date(), 'medium');
            $scope.model.type = this.state.type;
            this.state.type = null;
            $scope.model.picture = picture;
            $scope.model.ip = $scope.me.privateData.ip;
          });
        };

        this.reset = function () {
          angular.extend($scope.model, $scope.details.data);
          if (this.state.type === 'draw') {
            $scope.signaturePad.clear();
          } else {
            $scope.model.name = '';
          }
        };

        this.cancel = () => {
          this.state.type = null;
          $scope.model.signing = false;
          $scope.model.signIp = null;
          $scope.signaturePad.clear();
          $scope.model.name = null;
        };
      }
    )
    .directive('tcSignature', function ($window) {
      function resizeCanvas(canvas) {
        var ratio = $window.devicePixelRatio || 1;
        canvas.width = 300 * ratio;
        canvas.height = 82 * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
      }

      return {
        restrict: 'E',
        templateUrl:
          '/app/realtime/components/teleconsent/action/document/signature/' +
          'action.document.signature.tpl.html',
        scope: {
          model: '=ngModel',
          details: '=dDetails',
          disabled: '=dDisabled',
          me: '=dMe',
        },
        controller: 'TcSignatureController as vm',
        link: function (scope, elem) {
          var canvas = elem.find('canvas')[0];
          resizeCanvas(canvas);
          scope.signaturePad = new SignaturePad(canvas);
        },
      };
    });
})();
